import React, { FunctionComponent, SyntheticEvent, useState } from 'react';
import { Url } from '../../interfaces/common';
import './Image.scss';

export interface ImageProps {
  src: Url;
  alt?: string;
  title?: string;
}

export interface ImageSize {
  width: number;
  height: number;
}

const Image: FunctionComponent<ImageProps> = ({
  src,
  alt,
  title,
}: ImageProps) => {
  const [size, setSize] = useState<ImageSize>({ width: 0, height: 0 });
  const handleLoad = (event: SyntheticEvent<HTMLImageElement>): void => {
    const { naturalWidth, naturalHeight } = event.target as HTMLImageElement;
    setSize({ width: naturalWidth, height: naturalHeight });
  };

  return (
    <img
      src={src}
      alt={alt}
      title={title}
      width={size.width}
      // height={size.height}
      onLoad={handleLoad}
      className={size.width ? 'loaded' : 'loading'}
    />
  );
};

export default Image;
